export const JSON_ONE99NW = [
  {
    publishId: "GDB-092723115000-219",
    meId: "202308160003",
    Data: {
      AuthRR: [],
      AuthVRR: [],
      CaptureRR: [],
      SaleRR: [],
      RefundRI: [],
      RequestSTPGoB: [
        {
          agRef: "2058621695800469112",
          txnDate: "2023-09-27T11:47:25.823",
        },
      ],
      ResponseRFPGoB: [],
      VerificationRSTPGoB: [],
      VerificationRRFPGoB: [],
      NoRRFPGoB: [],
      AuthRP: [],
      AuthRF: [],
      AuthVRP: [],
      AuthVRF: [],
      CaptureRP: [],
      CaptureRF: [],
      SaleRP: [],
      SaleRF: [],
      RefundRP: [],
      RefundRF: [],
      ReconciledWRGoB: [],
      SettlementD: [],
      ReconciledM: [],
      MerchantPD: [],
      CancelledBC: [],
      Aborted: [],
      HostTO: [],
      pgRef: "",
      orderNo: "17298aa",
      amount: "199.00",
      status: "05",
      AmountM: [],
    },
  },
];
